import { GalleryItem } from './../models/gallery-item';
import { Injectable } from '@angular/core';
import { Api } from './api/api';
import * as Constants from '../app.constants';
import { Poi } from '../models/poi';
import { Localizzazione } from '../models/localizzazione';
import { FavouriteService } from 'src/app/services/favourite.service';
import { DatePipe } from '@angular/common';
import { ElencoPoi } from '../models/elenco-poi';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CacheService } from 'ionic-cache';
import { TTL_POI } from 'src/app/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { reject } from 'q';
import { environment } from 'src/environments/environment';
import { Raccomandazione, RaccomandazioneResponse } from '../models/raccomandazione';
import { RecommendationEngineService } from './recommendation-engine.service';
import { Image } from '@ks89/angular-modal-gallery';
import { error } from '@angular/compiler/src/util';

@Injectable({
  providedIn: 'root'
})
export class PoiService {
  constructor(
    private api: Api, 
    private favouriteService: FavouriteService, 
    private translateService: TranslateService, 
    private httpClient: HttpClient, 
    private reService: RecommendationEngineService,

    private cache: CacheService) {
  }

  estraiDate(obj: Poi) {
    let dataGlobaleInizio: Date;
    let dataGlobaleFine: Date;

    if (obj.opening) {
      obj.opening.forEach(element => {
        let dataInizioOpening: Date;
        let dataFineOpening: Date;

        if (element.startDate) {
          dataInizioOpening = new Date(element.startDate[0], element.startDate[1] - 1, element.startDate[2]);
          if (!dataGlobaleInizio || (dataGlobaleInizio && dataInizioOpening < dataGlobaleInizio)) {
            dataGlobaleInizio = dataInizioOpening;
          }
        }

        if (element.endDate) {
          dataFineOpening = new Date(element.endDate[0], element.endDate[1] - 1, element.endDate[2]);
          if (!dataGlobaleFine || (dataGlobaleFine && dataFineOpening > dataGlobaleFine)) {
            dataGlobaleFine = dataFineOpening;
          }
        }
        //Mentre itero sui periodo, setto anche la stringa della fascia oraria
        element.periodoLong = this.formatPeriodo(dataInizioOpening, dataFineOpening, 'long');

        //Imposto la fascia oraria
        if (element.openingTimes) {
          element.openingTimes.forEach(hours => {
            if (hours.startHour[0] === 0 && hours.startHour[1] === 0 && hours.endHour[0] === 23 && hours.endHour[1] === 59) {
              this.translateService.get('DETAIL.OPENINGINFO_TIMES_ALWAYS_OPEN').subscribe(value => {
                hours.fasciaOrariaString = value;
              });
            } else {
              hours.fasciaOrariaString = this.toTime(hours.startHour) + '-' + this.toTime(hours.endHour);
            }
          });
        }
      });
    }
  }

  toTime(date: Date) {
    const hours = '0' + date[0];
    const minutes = '0' + date[1];
    const time = hours.substr(hours.length - 2) + ':' + minutes.substr(minutes.length - 2);
    return time;
  }
  formatPeriodo(dataInizio: Date, dataFine: Date, mode: string) {
    const datePipe = new DatePipe(this.translateService.currentLang);

    let dataEvento;
    let pattern = 'dd MMMM';
    let patternWithYear = 'dd MMMM yyyy';
    if (mode === 'short') {
      pattern = 'dd MMM';
      patternWithYear = 'dd/MM/yy';
    }

    if (dataInizio != null && dataFine != null && dataInizio.getFullYear() === dataFine.getFullYear() && dataInizio.getMonth() === dataFine.getMonth()) {
      dataEvento = `${dataInizio.getDate()} - ${datePipe.transform(dataFine, pattern)}`;
    } else if (dataInizio != null && dataFine != null && !(dataInizio.getFullYear() === dataFine.getFullYear()) && dataInizio.getMonth() === dataFine.getMonth()) {
      dataEvento = `${datePipe.transform(dataInizio, patternWithYear)} - ${datePipe.transform(dataFine, patternWithYear)}`;
    } else if (dataInizio != null && dataFine == null) {
      dataEvento = `${datePipe.transform(dataInizio, pattern)}`;
    } else {
      dataEvento = `${datePipe.transform(dataInizio, pattern)} - ${datePipe.transform(dataFine, pattern)}`;
    }
    return dataEvento;
  }




  formatIndirizzoEsteso(evento: Poi) {
    let indirizzoEsteso = ``;
    if (evento) {

      let indirizzo = '';
      let comune = '';
      let provincia = '';

      if (evento.address) {
        indirizzo = indirizzo.concat(evento.address);
        if (evento.nhouse && evento.nhouse != '0') {
          indirizzo = indirizzo.concat(`, ${evento.nhouse}`);
        }
      }
      if (evento.city) {
        comune = evento.city;
      }
      if (evento.province) {
        provincia = provincia.concat(` (`, evento.province, `)`);
      }
      
      switch (Constants.MODE_APP_LOCALE) {
        case Constants.MODE_APP_LOCALE_CITY_ADDRESS:
          indirizzoEsteso = indirizzo.concat(` - `, comune, ``);
          break;
        case Constants.MODE_APP_LOCALE_CITY:
          indirizzoEsteso = comune;
          break;
        case Constants.MODE_APP_LOCALE_ADDRESS:
          indirizzoEsteso = indirizzo;
          break;      
        default:
          break;
      }
    }

    return indirizzoEsteso;
  }
  

  loadFromCache(path) {
    if ( !this.cache ) {
      console.error('cache ERROR!');
    }
    
    this.cache.enableCache(false);

    
    this.cache.setDefaultTTL(60 * Constants.TTL_POI);
  
    let headers = new HttpHeaders({
      'Accept-Language': this.translateService.currentLang
    });
    let options = { headers: headers };

    let cacheKey = path + '&' + this.translateService.currentLang;


    let request = this.httpClient.get(path, options);
    return this.cache.loadFromObservable(cacheKey, request);

  }

  getPois() {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_POI_URL}${Constants.LIST_POI_URL}?landId=${environment.api.tenantId}`;

      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoPoi = new ElencoPoi();
          elencoPoi.elenco = res.content;
          elencoPoi.page = res.number;
          elencoPoi.size = res.size;
          elencoPoi.maximumPages = res.totalPages;
          elencoPoi.totalElements = res.totalElements;

          const obj = elencoPoi.elenco;

          for (const key in obj) {
            if (obj[key]) {
              obj[key].indirizzoEsteso = this.formatIndirizzoEsteso(obj[key]);

              this.estraiDate(obj[key]);

              //Recupero i favourite dallo storage
              obj[key].isFavourite = await this.favouriteService.isFavorite(obj[key].id, obj[key].typeElement.key);
            }
          }
          resolve(elencoPoi);
        },
        err => {
          console.error('Lista vuota');
          reject(new ElencoPoi());
        }
      );
    });
  }

  getPoi(poi: Poi) {
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_POI_URL}${Constants.LIST_POI_URL}${poi.id}?landId=${environment.api.tenantId}`;
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          if (res) {



            let mediaServerLandUrl = `?landId=${environment.api.tenantId}`;
            let mediaServerBaseURL =
              Constants.API_BASE_URL +
              Constants.BASE_MEDIA_URL +
              Constants.MEDIASERVER_DOWNLOAD_URL;


            res.indirizzoEsteso = this.formatIndirizzoEsteso(res);
            this.estraiDate(res);

            /**
             * Recupero la Gallery
             */
              res.galleryImages = [];
              if ( res.gallery ) {
                let mapGallery = new Map(Object.entries( res.gallery ));
                mapGallery.forEach( (element:GalleryItem,key) => {
                
                  res.galleryImages.push( new Image(+key,      {
                    img: mediaServerBaseURL + element.image + mediaServerLandUrl,
                    description: element.captionGalleryImg
                  },
                  {
                    img: mediaServerBaseURL + element.thumbnail + mediaServerLandUrl,
                    title: element.captionGalleryImg,
                    alt: element.captionGalleryImg,
                    ariaLabel: element.captionGalleryImg,
                  }) );

                });
              }

            //Recupero i favourite dallo storage
            res.isFavourite = await this.favouriteService.isFavorite(res.id, res.typeElement.key);
         
            resolve(res);

          } else {
            console.error('Elemento non trovato');
            reject();
          }

        },
        err => {
          console.error('Lista vuota');
          reject(new Poi());
        }
      );
    });
  }
  getPoiById(id: string) {
    const poi = new Poi();
    poi.id = id;
    return this.getPoi(poi);
  }

  getPoisByType(tipo: string) {
    console.log('getPoisByType');
    return new Promise((resolve, reject) => {
      const path = `${Constants.API_BASE_URL}${Constants.BASE_POI_URL}${Constants.LIST_POI_URL}?landId=${environment.api.tenantId}&typeElementKey=${tipo}&from=0&to=100`;

      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoPoi = new ElencoPoi();
          elencoPoi.elenco = res.content;
          elencoPoi.page = res.number;
          elencoPoi.size = res.size;
          elencoPoi.maximumPages = res.totalPages;
          elencoPoi.totalElements = res.totalElements;

          const obj = elencoPoi.elenco;

          for (const key in obj) {
            if (obj[key]) {
              /*
              obj[key].thumbnail = Constants.MEDIASERVER_BASE_URL + obj[key].thumbnail;
              obj[key].image = Constants.MEDIASERVER_BASE_URL + obj[key].image;
              */
              obj[key].indirizzoEsteso = this.formatIndirizzoEsteso(obj[key]);

              this.estraiDate(obj[key]);

              //Recupero i favourite dallo storage
              obj[key].isFavourite = await this.favouriteService.isFavorite(obj[key].id, obj[key].typeElement.key);
            }
          }
          resolve(elencoPoi);
        },
        err => {
          console.error('Lista vuota');
          reject(new ElencoPoi());
        }
      );
    });
  }


  searchNearPosition( position: Localizzazione,distance: number, page:number, size: number, idsToExclude ) {
    return this.search(
      ``,
      ``,
      ``,
      ``,
      idsToExclude,
      ``,
      position,
      distance,
      page,
      size
    );
  }

  search(typePoi: string, 
    cityIds: string, 
    categoriesKey: string, 
    tagsKey: string, 
    idsToExclude?: string, 
    title?: string, 
    localizzazione?: Localizzazione,
     distanza?: number, 
     page?: number, 
     size?: number) {
    let path = `${Constants.API_BASE_URL}${Constants.BASE_POI_URL}${Constants.LIST_POI_URL}?landId=${environment.api.tenantId}`;
    
    if (typePoi) {
      path = path.concat(`&typeElementKey=${typePoi}`);
    }
    if(cityIds){
      path = path.concat(`&cityIds=${cityIds}`);
    }
    if (categoriesKey) {
      path = path.concat(`&categoriesKey=${categoriesKey}`);
    }
    if (tagsKey) {
      path = path.concat(`&tagsKey=${tagsKey}`);
    }
    if (localizzazione && localizzazione.latitude) {
      path = path.concat(`&latitude=${localizzazione.latitude}`);
    }
    if (localizzazione && localizzazione.longitude) {
      path = path.concat(`&longitude=${localizzazione.longitude}`);
    }
    if (localizzazione && distanza) {
      path = path.concat(`&distance=${distanza}`);
    }
    if (idsToExclude) {
      path = path.concat(`&idsToExclude=${idsToExclude}`);
    }
    if (title) {
      path = path.concat(`&title=${title}`);
    }
    if (page) {
      path = path.concat(`&page=${page}`);
    }
    if (size) {
      path = path.concat(`&size=${size}`);
    }

    console.log('path ' + path);


    return new Promise((resolve, reject) => {
      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoPoi = new ElencoPoi();

          if ( res ) {
            elencoPoi.elenco = res.content;
            elencoPoi.page = res.number;
            elencoPoi.size = res.size;
            elencoPoi.maximumPages = res.totalPages;
            elencoPoi.totalElements = res.totalElements;
  
            const obj = elencoPoi.elenco;
  
            for (const key in obj) {
              if (obj[key]) {
                obj[key].indirizzoEsteso = this.formatIndirizzoEsteso(obj[key]);
  
                this.estraiDate(obj[key]);
  
                //Recupero i favourite dallo storage
                obj[key].isFavourite = await this.favouriteService.isFavorite(obj[key].id, obj[key].typeElement.key);
              }
            }
            resolve(elencoPoi);

          } else {
            console.error('Lista vuota');

            reject();

          }

        },
        err => {
          console.error('Lista in errore');

          console.error(err);

          reject(new ElencoPoi());
        }
      );
    });
  }

  getAllAttractorNear(poi: Poi) {
    return this.getPoisNear(Constants.POY_TYPE.ATTRACTOR.KEY, ``, poi.geoLocation, Constants.NEARME_LIMIT_DISTANCE, poi.id);
  }
  getAllRestaurantNear(poi: Poi) {
    return this.getPoisNear(Constants.POY_TYPE.RESTAURANT.KEY, ``, poi.geoLocation, Constants.NEARME_LIMIT_DISTANCE, poi.id);
  }
  getAllAccomodationNear(poi: Poi) {
    return this.getPoisNear(Constants.POY_TYPE.ACCOMODATION.KEY, ``, poi.geoLocation, Constants.NEARME_LIMIT_DISTANCE, poi.id);
  }

  /* Cerca tutti i POI della stessa tipologia, filtrando per categoria, per vicinanza ed escludendo un determino id */
  getOtherPoisByCategories(poi: Poi) {
    let keyCategories = '';
    if (poi.categories) {
      poi.categories.forEach(element => {
        keyCategories = keyCategories.concat(element.key, ',');
        
      });
    }
    return this.getPoisNear(poi.typeElement.key, keyCategories, poi.geoLocation, Constants.NEARME_LIMIT_DISTANCE, poi.id);
  }

  /* Cerca tutti i POI della stessa tipologia, per vicinanza ed escludendo un determino id */
  getOtherPois(poi: Poi) {
    return this.getPoisNear(poi.typeElement.key, ``, poi.geoLocation, Constants.NEARME_LIMIT_DISTANCE, poi.id);
  }

  getPoisNear(typePoi: string, categories: string, localizzazione: Localizzazione, distanza?: number, idsToExclude?: string) {
    return new Promise((resolve, reject) => {

      //console.log('getPoisNear');

      const path = `${Constants.API_BASE_URL}${Constants.BASE_POI_URL}${Constants.LIST_POI_URL}?landId=${environment.api.tenantId}&typeElementKey=${typePoi}&categoriesKey=${categories}&latitude=${localizzazione.latitude}&longitude=${localizzazione.longitude}&distance=${distanza}&idsToExclude=${idsToExclude}`;

      this.loadFromCache(path).subscribe(
        async (res: any) => {
          const elencoPoi = new ElencoPoi();
          elencoPoi.elenco = res.content;
          elencoPoi.page = res.number;
          elencoPoi.size = res.size;
          elencoPoi.maximumPages = res.totalPages;
          elencoPoi.totalElements = res.totalElements;

          const obj = elencoPoi.elenco;

          for (const key in obj) {
            if (obj[key]) {
              obj[key].indirizzoEsteso = this.formatIndirizzoEsteso(obj[key]);
              this.estraiDate(obj[key]);

              //Recupero i favourite dallo storage
              obj[key].isFavourite = await this.favouriteService.isFavorite(obj[key].id, obj[key].typeElement.key);
            }
          }
          resolve(elencoPoi);
        },
        err => {
          console.error('Lista vuota');
          reject(new ElencoPoi());
        }
      );
    });
  }
}
